import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";

import type { FindingSeverity } from "./Finding";

const BETTER = msg({
  id: "analysis.metric.better",
  message: "better than {count} of 100",
});
const WORSE = msg({
  id: "analysis.metric.worse",
  message: "worse than {count} of 100",
});
const USUAL = msg({ id: "analysis.metric.usual", message: "on par" });

// Сравнение метрики с сильными игроками словами, без перевёрнутых перцентилей: у плохой
// метрики «хуже, чем у 92 из 100», а не «лучше, чем у 8 из 100». `null` — значение обычное.
export const metricComparison = (
  severity: FindingSeverity | null,
  percentile: number,
): { descriptor: MessageDescriptor; values: { count: number } } => {
  const better = Math.round(percentile);
  if (severity === "good") {
    return { descriptor: BETTER, values: { count: better } };
  }
  if (severity === "warn" || severity === "bad") {
    return { descriptor: WORSE, values: { count: 100 - better } };
  }
  return { descriptor: USUAL, values: { count: better } };
};
